<template>
  <div>
    <div class="lftj_title">全天各时段来访情况统计</div>
    <div class="lftj_search">
      <span style="font-size:13px;font-weight:bold;">统计时段：</span>
      <el-radio-group v-model="selectItem" size="mini" @change="select()">
        <el-radio :label="1">本周</el-radio>
        <el-radio :label="2">本月</el-radio>
        <el-radio :label="3">本季</el-radio>
        <el-radio :label="4">本年</el-radio>
        <el-radio :label="5">其他</el-radio>
      </el-radio-group>
      <el-date-picker
        v-model="searchDate"
        type="daterange"
        size="mini"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:200px; margin-right:10px;"
        :disabled="disabled"
      ></el-date-picker>
       <el-button type="primary" size="mini" @click="getListData()">统计</el-button>
      <el-button type="primary" size="mini" v-show="false">导出</el-button>
    </div>
    <el-row style=" margin:20px">
      <el-col :span="12">
        <div style="width:80%">
          <ve-line :data="chartData" :extend="extend" :settings="chartSettings"></ve-line>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="width:80%;margin-top: 60px;">
          <el-table :data="chartData.rows" width="80%" border>
            <el-table-column label="序号" width="70">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.$index+1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="时段" label="时段"></el-table-column>
            <el-table-column prop="受访次数" label="受访次数"></el-table-column>
            <el-table-column prop="来访人数" label="来访人数"></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getVisitorListCount } from "@/api/api";
export default {
  data() {
    return {
      user: {},
      selectItem: 1, //当前选择的tip
      disabled: true, //是否显示统计时间
      searchDate: "", //查询时间
     chartHeight: "400px", //chart高度（默认400px，可在create中初始化）
      chartSettings: {
        //线形图统计（横向和纵向）
        dimension: ["时段"],
        metrics: ["受访次数","来访人数"]
      },
      extend: {
        "xAxis.0.axisLabel.rotate": 45,
        series: {
        smooth: false
      }
      },
      chartData: {
        columns: ["时段", "受访次数", "来访人数"],
        rows: [
          { 时段: "00:00—08:00", 受访次数: 1, 来访人数: 3 },
          { 时段: "08:00—10:00", 受访次数: 2, 来访人数: 4 },
          { 时段: "10:00—12:00", 受访次数: 3, 来访人数: 48 },
          { 时段: "12:00—16:00", 受访次数: 4, 来访人数: 14 },
          { 时段: "16:00—20:00", 受访次数: 5, 来访人数: 20 },
          { 时段: "20:00—24:00", 受访次数: 5, 来访人数: 20 }
        ]
      }
    };
  },
  mounted() {
    this.user = JSON.parse(window.localStorage.user);
    this.getListData();
  },
  methods: {
    //查询列表
    getListData() {
      this.chartData.rows=[];
      var _this = this;
      var para = {
        params: {
          companyId: this.user.companyId,
          queryBy: 3,
          queryType : this.selectItem,
          startTime: this.searchDate[0],
          endTime: this.searchDate[1]
        }
      };
      getVisitorListCount(para).then(res => {
        var data = JSON.parse(res.data);
        if (data.Success) {
          var list = data.Data;
          if (list.length > 0) {
            list.forEach(element => {
               _this.chartData.rows.push({
                时段: element.TimeInterval,
                受访次数: element.CountVisit===null?0:element.CountVisit,
                来访人数: element.VisitsNumber===null?0:element.VisitsNumber
              });
            });
             _this.chartHeight = (list.length * 60+120) + "px";
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    select() {
      this.disabled = true;
      if (this.selectItem === 5) {
        this.disabled = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/fksys/lftj/lfsd.vue